export const EndPoints = {
  RESET_PASSWORD: {
    FRANCHISE_UPDATE: "LIS/master/reset_password/franchisemaster",
    EMPLOYEE_UPDATE: "hrms/master/reset_password/employee",
    AGENT_UPDATE: "hrms/master/reset_password/patient_coordinator_agent/",
  },
  PatientGraph: {
    GRAPHSTATSLIST: "reports/dashboard/stats",
    PATIENTLIST: "reports/dashboard/patient_graph",
    HEADER_DETAILS: "LISdashboard/header/details",
  },
  EmployeeCatergory: {
    LIST: "hrms/employees/category/dropdown",
  },
  City: {
    LIST: "LIS/city/master",
    LIST_BY_STATE_ID: "LIS/get_city/",
  },
  Franchise: {
    CREATE: "LIS/create/franchise/master",
    LIST: "LIS/franchise_master/master/list",
    ONLY_PARENT_FRANCHISE_LIST:
      "LIS/franchise_master/master/ony_parent_franchise_dd",
    LIST_DD: "LIS/franchise_master/master/franchise_dd",
    LIST_BY_ID: "LIS/master/list/franchisemaster_by_id",
    EXISTS_USERNAME: "hrms/master/employee/exists_username/",
    UPDATE: "LIS/master/update/franchisemaster",
    DELETE: "LIS/master/delete/franchisemaster",
    DOWNLOAD_CSV: "LIS/master/franchisemaster/downloadcsv",
    ALLOT_BARCODE: "LIS/franchise/allot_barcodes",
    COPY_RATES_LOG_LIST: "LIS/master/list/franchise_copy_rates_log",
    ACTIVE: "LIS/master/update/franchisemaster/activate_franchise",
    FRANCHISE_TOP_PERFORMER:
      "reports/franchise/business/date_wise_top_performers",
  },
  PackageInvestigationMaster: {
    CREATE: "LIS/master/create/packageinvestigationmaster",
    LIST: "LIS/master/list/packageinvestigationmaster",
    UPDATE: "LIS/master/update/packageinvestigationmaster",
    DELETE: "LIS/master/delete/packageinvestigationmaster",
    DOWNLOAD_CSV: "LIS/master/packageinvestigationmaster/downloadcsv",
  },
  PatientReceipt: {
    LIST: "LIS/master/list/patientappointment_full_detail",
  },
  PatientSettlement: {
    CREATE: "LIS/master/create/capture_patient_appointment_balance_payment",
  },
  PatientAppointmentDetails: {
    CREATE: "LIS/master/create/patientappointmentdetail",
    LIST: "LIS/master/list/patientappointmentdetail",
    UPDATE: "LIS/master/update/patientappointmentdetail",
    DELETE: "LIS/master/delete/patientappointmentdetail",
    DOWNLOAD_CSV: "LIS/master/patientappointmentdetail/downloadcsv",
    CHANGE_FRANCHISE: "LIS/master/update/patientappointment/change_franchise",
    CHANGE_BARCODE: "LIS/master/update/patientappointment/change_barcode",
    GET_SAMPLEWISE_BARCODE:
      "LIS/master/get/patientappointment/get_samplewise_barcode",
    SAMPLE_REJECTED_LIST:
      "LIS/master/list/patientappointment_list_rejected_sample_data",
    CANCELLATION: "LIS/master/cancel/patientappointmentdetail/investigations",
  },
  PackageInvestigation: {
    CREATE: "LIS/master/create/packageinvestigation",
    PACKAGELIST: "LIS/master/list/investigation/",
    LIST: "LIS/master/list/packagemaster",
    UPDATE: "LIS/master/update/packagemaster",
    DELETE: "LIS/master/delete/packagemaster",
    DOWNLOAD_CSV: "LIS/master/packagemaster/downloadcsv",
  },
  InvestigationSequence: {
    CREATE: "LIS/master/create/investigation_sequencemaster",
    BULKUPDATE: "LIS/master/bulkupdate/investigation_sequencemaster",
    LIST: "LIS/master/list/all_investigation_list",
    SEQUENCE: "LIS/master/list/investigation_sequencemaster",
    UPDATE: "LIS/master/update/investigation_sequencemaster",
    DELETE: "LIS/master/delete/investigation_sequencemaster",
    DOWNLOAD_CSV: "LIS/master/investigation_sequencemaster/downloadcsv",
  },
  InvestigationObservation: {
    CREATE: "LIS/master/create/investigation_observationmaster",
    LIST: "LIS/master/list/investigation_observationmaster",
    MULTIPLEOBSERVATIONlIST: "LIS/master/list/observationmaster_dd",
    UPDATE: "LIS/master/update/investigation_observationmaster",
    DELETE: "LIS/master/delete/investigation_observationmaster",
    DOWNLOAD_CSV: "LIS/master/investigation_observationmaster/downloadcsv",
  },
  Organism: {
    CREATE: "LIS/master/create/organismmaster",
    LIST: "LIS/master/list/organismmaster",
    UPDATE: "LIS/master/update/organismmaster",
    DELETE: "LIS/master/delete/organismmaster",
    DOWNLOAD_CSV: "LIS/master/organismmaster/downloadcsv",
  },
  DoctorsSepcialization: {
    CREATE: "LIS/master/create/doctor_specializationmaster",
    LIST: "LIS/master/list/doctor_specializationmaster",
    UPDATE: "LIS/master/update/doctor_specializationmaster",
    DELETE: "LIS/master/delete/doctor_specializationmaster",
    DOWNLOAD_CSV: "LIS/master/doctor_specializationmaster/downloadcsv",
  },
  DoctorsDegree: {
    CREATE: "LIS/master/create/doctor_degreemaster",
    LIST: "LIS/master/list/doctor_degreemaster",
    UPDATE: "LIS/master/update/doctor_degreemaster",
    DELETE: "LIS/master/delete/doctor_degreemaster",
    DOWNLOAD_CSV: "LIS/master/doctor_degreemaster/downloadcsv",
  },
  DiscountReason: {
    CREATE: "LIS/master/create/discount_reasonmaster",
    LIST: "LIS/master/list/discount_reasonmaster",
    UPDATE: "LIS/master/update/discount_reasonmaster",
    DELETE: "LIS/master/delete/discount_reasonmaster",
    DOWNLOAD_CSV: "LIS/master/discount_reasonmaster/downloadcsv",
  },
  FranchiseType: {
    CREATE: "LIS/master/create/franchisetypes",
    LIST: "LIS/master/list/franchisetypes",
    UPDATE: "LIS/master/update/franchisetypes",
    DELETE: "LIS/master/delete/franchisetypes",
    DOWNLOAD_CSV: "LIS/master/franchisetypes/downloadcsv",
  },
  DepartmentType: {
    CREATE: "LIS/master/create/departmenttypemaster",
    LIST: "LIS/master/list/departmenttypemaster",
    UPDATE: "LIS/master/update/departmenttypemaster",
    DELETE: "LIS/master/delete/departmenttypemaster",
    DOWNLOAD_CSV: "LIS/master/departmenttypemaster/downloadcsv",
  },
  LabDepartment: {
    CREATE: "LIS/master/create/labdepartmentmaster",
    LIST: "LIS/master/list/labdepartmentmaster",
    UPDATE: "LIS/master/update/labdepartmentmaster",
    DELETE: "LIS/master/delete/labdepartmentmaster",
    DOWNLOAD_CSV: "LIS/master/labdepartmentmaster/downloadcsv",
  },
  CollectionType: {
    CREATE: "LIS/master/create/collectiontypemaster",
    LIST: "LIS/master/list/collectiontypemaster",
    UPDATE: "LIS/master/update/collectiontypemaster",
    DELETE: "LIS/master/delete/collectiontypemaster",
    DOWNLOAD_CSV: "LIS/master/collectiontypemaster/downloadcsv",
  },
  Circular: {
    CREATE: "LIS/master/create/circularmaster",
    LIST: "LIS/master/list/circularmaster",
    UPDATE: "LIS/master/update/circularmaster",
    DELETE: "LIS/master/delete/circularmaster",
    DOWNLOAD_CSV: "LIS/master/circularmaster/downloadcsv",
  },
  BRANCH: {
    CREATE: "hrms/master/create/branch",
    LIST: "hrms/master/list/branch",
    UPDATE: "hrms/master/update/branch",
    DELETE: "hrms/master/delete/branch",
    DOWNLOAD_CSV: "hrms/master/branch/downloadcsv",
  },
  Zone: {
    CREATE: "LIS/master/create/zone",
    LIST: "LIS/zone/master",
    LIST_BY_ID: "LIS/master/list/zonemaster/zone_detail",
    UPDATE: "LIS/master/update/zonemaster",
    DELETE: "LIS/master/delete/zonemaster",
    DOWNLOAD_CSV: "LIS/master/zonemaster/downloadcsv",
    ZONE_LOGO_BY_ID: "LIS/master/zonemaster/download_zone_logo",
  },
  Area: {
    CREATE: "LIS/master/create/areamaster",
    LIST: "LIS/master/list/areamaster",
    UPDATE: "LIS/master/update/areamaster",
    DELETE: "LIS/master/delete/areamaster",
    DOWNLOAD_CSV: "LIS/master/areamaster/downloadcsv",
  },
  // CREATEDEPARTMENT: "hrms/master/create/department",
  // CREATEBRANCH: "hrms/master/create/branch",
  // STATEBYCOUNTRY: "LIS/get_state/",
  // CITYBYSTATE: "LIS/get_city/",
  // ZONELIST: "LIS/zone/master",
  ZONELISTDD: "LIS/zone/master/zone_dd",
  // CREATEROLE: "hrms/master/create/roles",
  // CREATEDESIGNATION: "hrms/master/create/designation",
  // GETDEPARTMENT: "hrms/master/list/department",
  // PANELTYPEMASTER: "LIS/master/create/franchisetypes",
  // ADDZONEMASTER: "LIS/master/create/zone",
  // ADDAREAMASTER: "LIS/master/create/areamaster",
  // ADDCIRUCLARMASTER: "LIS/master/create/circularmaster",
  // DISCOUNTMASTER: "LIS/master/create/discount_reasonmaster",
  // DOCTORMASTER: "LIS/master/create/doctor_degreemaster",
  // DOCTORSPECIALIZATION: "LIS/master/create/doctor_specializationmaster",
  // BRANCHLISTING: "hrms/master/list/branch/",
  // DELETEBRANCH: "hrms/master/delete/branch/",
  SAMPLESTATUS: "LIS/master/list/appointmentstatusmaster",
  DEPARTMENT: {
    CREATE: "hrms/master/create/department",
    LIST: "hrms/master/list/department",
    UPDATE: "hrms/master/update/department",
    DELETE: "hrms/master/delete/department",
    DOWNLOAD_CSV: "hrms/master/department/downloadcsv",
  },
  DESIGNATION: {
    CREATE: "hrms/master/create/designation",
    LIST: "hrms/master/list/designation",
    UPDATE: "hrms/master/update/designation",
    DELETE: "hrms/master/delete/designation",
    DOWNLOAD_CSV: "hrms/master/designation/downloadcsv",
  },
  EMPLOYEE: {
    CREATE: "hrms/master/create/employee",
    LIST: "hrms/master/list/employee",
    UPDATE: "hrms/master/update/employee",
    DELETE: "hrms/master/delete/employee",
    DOWNLOAD_CSV: "hrms/master/employee/downloadcsv",
    ACTIVE: "hrms/master/update/employee/activate_employee",
  },
  EMPLOYEETYPE: {
    CREATE: "hrms/master/create/employeetypes",
    LIST: "hrms/master/list/employeetypes",
    UPDATE: "hrms/master/update/employeetypes",
    DELETE: "hrms/master/delete/employeetypes",
    DOWNLOAD_CSV: "hrms/master/employeetypes/downloadcsv",
  },
  LEAVE_MASTER: {
    CREATE: "hrms/master/create/employee_leaves_master",
    LIST: "hrms/master/list/employee_leaves_master",
    UPDATE: "hrms/master/update/employee_leaves_master",
    DELETE: "hrms/master/delete/employee_leaves_master",
    DROPDOWN: "hrms/master/list/employee_leaves_master_dd",
    CREDIT: "hrms/master/credit/credit_employee_leaves_master",
  },
  UNIT: {
    LIST_DD: "inventory/master/list/productunitmaster_list_dd",
    CREATE: "inventory/master/create/productunitmaster",
  },
  EMPLOYEECATEGORY: {
    CREATES: "hrms/master/create/employeecategory",
    CREATE: "hrms/master/create/employeecategorymaster",
    LIST: "hrms/master/list/employeecategorymaster",
    UPDATE: "hrms/master/update/employeecategorymaster",
    DELETE: "hrms/master/delete/employeecategorymaster",
    DOWNLOAD_CSV: "hrms/master/employeecategorymaster/downloadcsv",
  },
  DISCOUNTREASON: {
    CREATE: "LIS/master/create/discount_reasonmaster",
    LIST: "LIS/master/list/discount_reasonmaster",
    UPDATE: "LIS/master/update/discount_reasonmaster",
    DELETE: "LIS/master/delete/discount_reasonmaster",
    DOWNLOAD_CSV: "LIS/master/discount_reasonmaster/downloadcsv",
  },
  PAYMENTMODE: {
    CREATE: "accounts/master/create/paymentmodemaster",
    LIST: "accounts/master/list/paymentmodemaster",
    UPDATE: "accounts/master/update/paymentmodemaster",
    DELETE: "accounts/master/delete/paymentmodemaster",
    DOWNLOAD_CSV: "accounts/master/paymentmodemaster/downloadcsv",
  },
  ADVANCEPAYMENT: {
    CREATE: "accounts/master/create/franchiseadvancepaymentmaster",
    UPDATE: "accounts/master/update/franchiseadvancepaymentmaster",
    BULK_UPDATE: "accounts/master/bulkupdate/franchiseadvancepaymentmaster",
    LIST: "accounts/master/list/franchiseadvancepaymentmaster",
    DELETE: "accounts/master/delete/franchiseadvancepaymentmaster",
    DOWNLOAD_CSV: "accounts/master/franchiseadvancepaymentmaster/downloadcsv",
    APPOINTMENT_PAYMENT_UPDATE:
      "LIS/master/update/patient_appointment_payment_detail/",
  },
  ROLE: {
    CREATE: "hrms/master/create/roles",
    LIST: "hrms/master/list/roles",
    UPDATE: "hrms/master/update/roles/",
    DELETE: "hrms/master/delete/roles",
    DOWNLOAD_CSV: "hrms/master/roles/downloadcsv",
  },
  DOCUMENT: {
    CREATE: "LIS/master/create/documentmaster",
    LIST: "LIS/master/list/documentmaster",
    UPDATE: "LIS/master/update/documentmaster",
    DELETE: "LIS/master/delete/documentmaster",
    DOWNLOAD_CSV: "LIS/master/documentmaster/downloadcsv",
  },
  SAMPLECOLLECTION: {
    LIST: "LIS/master/sample/list",
    CREATE: "LIS/master/sample/mark_collect_and_received",
    MACHINE_CREATE: "LIS/master/sample/print_sample_label_for_machine",
    SAMPLEINFORMATION: "LIS/new/registration/get_registration_detail",
  },
  SHARETYPE: {
    CREATE: "LIS/master/create/sharetypemaster",
    LIST: "LIS/master/list/sharetypemaster",
    UPDATE: "LIS/master/update/sharetypemaster",
    DELETE: "LIS/master/delete/sharetypemaster",
    DOWNLOAD_CSV: "LIS/master/sharetypemaster/downloadcsv",
  },
  SAMPLETYPE: {
    CREATE: "LIS/master/create/sampletypemaster",
    LIST: "LIS/master/list/sampletypemaster",
    UPDATE: "LIS/master/update/sampletypemaster",
    DELETE: "LIS/master/delete/sampletypemaster",
    DOWNLOAD_CSV: "LIS/master/sampletypemaster/downloadcsv",
    UPLOAD_VOIL_IMAGE: "LIS/master/sampletypemaster/upload_voil_image",
    GET_VOIL_IMAGE: "LIS/master/sampletypemaster/download_voil_image",
  },
  SAMPLEREJECTIONREASON: {
    CREATE: "LIS/master/create/samplerejectionreasonmaster",
    LIST: "LIS/master/list/samplerejectionreasonmaster",
    UPDATE: "LIS/master/update/samplerejectionreasonmaster",
    DELETE: "LIS/master/delete/samplerejectionreasonmaster",
    DOWNLOAD_CSV: "LIS/master/samplerejectionreasonmaster/downloadcsv",
  },
  PAYMENTTYPE: {
    CREATE: "accounts/master/create/paymenttypemaster",
    LIST: "accounts/master/list/paymenttypemaster",
    UPDATE: "accounts/master/update/paymenttypemaster",
    DELETE: "accounts/master/delete/paymenttypemaster",
    DOWNLOAD_CSV: "accounts/master/paymenttypemaster/downloadcsv",
  },
  INVESTIGATIONTEST: {
    CREATE: "LIS/master/create/investigationmaster",
    LIST: "LIS/master/list/investigationmaster",
    LIST_DD: "LIS/master/list/investigationmaster_dd",
    UPDATE: "LIS/master/update/investigationmaster",
    DELETE: "LIS/master/delete/investigationmaster",
    DOWNLOAD_CSV: "LIS/master/investigationmaster/downloadcsv",
  },
  INVESTIGATIONMANAGER: {
    CREATEHELPMENULIST: "LIS/master/create/investigation_helpmaster",
    CREATEINVESTIGATIONINTERPRETATIONLIST:
      "LIS/master/create/investigation_ineterpretationmaster",
    CREATEOBSERVATIONLIST:
      "LIS/master/bulkcreate/investigation_observationmaster",
    OBSERVATIONLIST: "LIS/master/list/observationmaster_dd",
    CREATE: "LIS/create/full/investigationmaster",
    CREATEINVESTIGATIONLIST: "LIS/master/create/investigation_commentmaster",
    LIST: "LIS/master/list/investigationmaster",
    UPDATE: "LIS/master/update/fullinvestigationmaster",
    DELETE: "LIS/master/delete/investigationmaster",
    DOWNLOAD_CSV: "LIS/master/investigationmaster/downloadcsv",
    INVESTIGATION_OBSERVATION_LIST:
      "LIS/master/list/investigation_observationmaster",
    UPDATE_INVESTIGATION_OBSERVATION_LIST:
      "LIS/master/bulkupdate/observationmaster_only/",
    DELETE_INVESTIGATION_OBSERVATION_LIST:
      "LIS/master/delete/investigation_observationmaster",
    INVESTIGATION_COMMENT_LIST: "LIS/master/list/investigation_commentmaster",
    INVESTIGATION_INTERPRETATION_LIST:
      "LIS/master/list/investigation_ineterpretationmaster",
    INVESTIGATION_HELP_MENU_LIST: "LIS/master/list/investigation_helpmaster",
    INVESTIGATION_OBSERVATION_RANGES_LIST:
      "LIS/master/list/investigation_observations_and_ranges",
    UPDATE_INVESTIGATION_OBSERVATION_SEQUENCE:
      "LIS/master/bulkupdate/investigation_observation_sequence/",
    SHOW_DUMMY_REPORT_DATA:
      "LIS/list/full_investigation/show_dummy_data_for_sample_pdf",
    ACTIVE: "LIS/master/update/activate_investigationmaster",
  },
  INVESTIGATION_OBSERVATION_FORMULA: {
    CREATE: "LIS/master/create/observationformula",
    UPDATE: "LIS/master/update/observationformula",
    LIST: "LIS/master/list/observationformula",
    DELETE: "LIS/master/delete/observationformula",
  },
  INVESTIGATIONTEMPLATE: {
    CREATE: "LIS/master/create/investigation_templatemaster",
    LIST: "LIS/master/list/investigation_templatemaster",
    LIST_BY_ID: "LIS/master/list/investigation_templatemaster",
    UPDATE: "LIS/master/update/investigation_templatemaster",
    DELETE: "LIS/master/delete/investigation_templatemaster",
    DOWNLOAD_CSV: "LIS/master/investigation_templatemaster/downloadcsv",
  },
  EMPDISCOUNTALLOWED: {
    CREATE: "LIS/master/create/employee_discount_allowedmaster",
    LIST: "LIS/master/list/employee_discount_allowedmaster",
    UPDATE: "LIS/master/update/employee_discount_allowedmaster",
    DELETE: "LIS/master/delete/employee_discount_allowedmaster",
    DOWNLOAD_CSV: "LIS/master/employee_discount_allowedmaster/downloadcsv",
  },
  INVESTIGATIONNABL: {
    CREATE: "LIS/master/create/investigation_nablmaster",
    LIST: "LIS/master/list/investigation_nablmaster",
    UPDATE: "LIS/master/update/investigation_nablmaster",
    DELETE: "LIS/master/delete/investigation_nablmaster",
    DOWNLOAD_CSV: "LIS/master/investigation_nablmaster/downloadcsv",
  },
  OUTSOURCEINVESTIGATION: {
    CREATE: "LIS/master/create/outsource_investigationmaster",
    LIST: "LIS/master/list/outsource_investigationmaster",
    UPDATE: "LIS/master/update/outsource_investigationmaster",
    DELETE: "LIS/master/delete/outsource_investigationmaster",
    DOWNLOAD_CSV: "LIS/master/outsource_investigationmaster/downloadcsv",
  },
  OUTSOURCELAB: {
    CREATE: "LIS/master/create/outsource_labmaster",
    LIST: "LIS/master/list/outsource_labmaster",
    UPDATE: "LIS/master/update/outsource_labmaster",
    DELETE: "LIS/master/delete/outsource_labmaster",
    DOWNLOAD_CSV: "LIS/master/outsource_labmaster/downloadcsv",
  },
  PACKAGE: {
    CREATE: "LIS/master/create/packageinvestigation",
    LIST: "LIS/master/list/packagemaster",
    LIST_BY_ID: "LIS/master/list/packagemaster",
    UPDATE: "LIS/master/update/packagemaster",
    UPDATE_ALL: "LIS/master/update/packagemaster_all",
    BULK_UPDATE: "LIS/master/bulkupdate/packagemaster_cost",
    DELETE: "LIS/master/delete/packagemaster",
    INVESTIGATION_DELETE: "LIS/master/delete/packageinvestigationmaster",
    DOWNLOAD_CSV: "LIS/master/packagemaster/downloadcsv",
  },
  TESTRATE: {
    CREATE: "LIS/master/create/test_ratemaster",
    LIST: "LIS/master/list/test_ratemaster",
    UPDATE: "LIS/master/update/test_ratemaster",
    DELETE: "LIS/master/delete/test_ratemaster",
    DOWNLOAD_CSV: "LIS/master/test_ratemaster/downloadcsv",
    DOWNLOAD_CSV_GENERATE_TEMPLATE:
      "LIS/master/test_ratemaster/generate_csv_template",
    DOWNLOAD_CSV_GENERATE_TEMPLATE_PACKAGE:
      "LIS/master/package_ratemaster/generate_csv_template_for_package",
    UPLOAD_TEST_RATE_CSV: "LIS/master/test_ratemaster/upload_test_rate_csv",
    UPLOAD_PACKAGE_RATE_CSV:
      "LIS/master/package_test_ratemaster/upload_package_rate_csv",
    COPY_RATES: "LIS/copy/rate/list",
    CREATE_COPY_RATES_LOG: "LIS/master/create/franchise_copy_rates_log",
  },
  PANELMASTER: {
    CREATE: "LIS/master/create/test_ratemaster",
    LIST: "LIS/master/list/panel_wise_test_ratemaster",
    VIEW_FRANCHISE_RATES_LIST:
      "LIS/master/list/list_panel_wise_test_ratemaster_for_view",
    LIS_FRANCHISE_COPY_RATE_LIST:
      "LIS/master/list/lis/panel_wise_test_ratemaster",
    MEDICITY_FRANCHISE_COPY_RATE_LIST:
      "LIS/master/list/panel_wise_test_ratemaster",
    MEDICITY_UPDATE: "LIS/master/LIS/update/bulk_update_test_ratemaster",
    PENDING_LIST: "LIS/get/pending/rate",
    UPDATE: "LIS/master/update/bulk_update_test_ratemaster",
    LIS_UPDATE: "LIS/master/lis/update/bulk_update_test_ratemaster",
    DELETE: "LIS/master/delete/test_ratemaster",
    DOWNLOAD_CSV: "LIS/master/test_ratemaster/downloadcsv",
    COPY_RATES: "LIS/copy/rate/list",
    SYNC: "LIS/master/franchisemaster/sync_all_investigations_to_test_rate_master",
    FRANCHISE_INVESTIGATION_DETAILS: "LIS/show/investigation/all_detail",
  },
  INVESTIGATIONHELP: {
    CREATE: "LIS/master/create/investigation_helpmaster",
    LIST: "LIS/master/list/investigation_helpmaster",
    UPDATE: "LIS/master/update/investigation_helpmaster",
    DELETE: "LIS/master/delete/investigation_helpmaster",
    DOWNLOAD_CSV: "LIS/master/investigation_helpmaster/downloadcsv",
  },
  INTERPRETATION: {
    CREATE: "LIS/master/create/investigation_ineterpretationmaster",
    LIST: "LIS/master/list/investigation_ineterpretationmaster",
    UPDATE: "LIS/master/update/investigation_ineterpretationmaster",
    DELETE: "LIS/master/delete/investigation_ineterpretationmaster",
    DOWNLOAD_CSV: "LIS/master/investigation_ineterpretationmaster/downloadcsv",
  },
  DELIVERY_DAYS: {
    CREATE: "LIS/master/create/investigation_delivery_daysmaster",
    LIST: "LIS/master/list/investigation_delivery_daysmaster",
    // UPDATE: "LIS/master/update/investigation_delivery_daysmaster",
    UPDATE: "LIS/master/update/all_zones/investigation_delivery_daysmaster",
    DELETE: "LIS/master/delete/investigation_delivery_daysmaster",
    DOWNLOAD_CSV: "LIS/master/investigation_delivery_daysmaster/downloadcsv",
  },
  INVESTIGATION_COMMENT: {
    CREATE: "LIS/master/create/investigation_commentmaster",
    LIST: "LIS/master/list/investigation_commentmaster",
    UPDATE: "LIS/master/update/investigation_commentmaster",
    DELETE: "LIS/master/delete/investigation_commentmaster",
    DOWNLOAD_CSV: "LIS/master/investigation_commentmaster/downloadcsv",
  },
  INVESTIGATIONDETAILS: {
    CREATE: "LIS/master/create/investigation_detailmaster",
    LIST: "LIS/master/list/investigation_detailmaster",
    UPDATE: "LIS/master/update/investigation_detailmaster",
    DELETE: "LIS/master/delete/investigation_detailmaster",
    DOWNLOAD_CSV: "LIS/master/investigation_detailmaster/downloadcsv",
  },
  DOCTOR: {
    INTERNAL_DOCTOR_LIST: "LIS/master/list/doctormaster_dd",
    DOCTOR_ASSIGN_ROLE: "result/reports/get/employee/assign/doctor",
    SIGNATURE_LIST: "LIS/master/get/download_doctor_signature",
    CREATE: "LIS/master/create/doctormaster",
    LIST: "LIS/master/list/doctormaster",
    UPDATE: "LIS/master/update/doctormaster",
    DELETE: "LIS/master/delete/doctormaster",
    DOWNLOAD_CSV: "LIS/master/doctormaster/downloadcsv",
    ACTIVE: "LIS/master/activate/doctormaster",
    LIST_DD: "LIS/master/list/doctormaster",
  },
  FRANCHISEDETAILS: {
    CREATE: "hrms/master/create/employeefranchisedetail",
    LIST: "hrms/master/list/employeefranchisedetail",
    DELETE: "hrms/master/delete/employeefranchisedetail",
  },
  EMPLOYEE_ROLES: {
    CREATE: "hrms/master/create/employeeroles",
    EMPLOYEE_WISE_ROLES: "hrms/master/list/employeeroles",
    DELETE: "hrms/master/delete/employeeroles",
  },
  DEPARTMENT_ROLES: {
    CREATE: "hrms/master/create/department_role",
    DEPARTMENT_WISE_ROLES: "hrms/master/list/department_role",
    DELETE: "hrms/master/delete/department_role",
  },
  PATIENT: {
    CREATE: "LIS/master/create/patientmaster",
    LIST: "LIS/master/list/patientmaster",
    UPDATE: "LIS/master/update/patientmaster",
    DELETE: "LIS/master/delete/patientmaster",
    DOWNLOAD_CSV: "LIS/master/patientmaster/downloadcsv",
    DOCUMENTTYPELIST: "LIS/master/list/documentmaster",
  },
  APPOINTMENT_PAYMENT: {
    CREATE: "LIS/master/create/online_payments_with_detail",
    ORDER_CREATE: "LIS/master/create/online_payments_create_order",
    CAPTURE_CREATE: "LIS/master/create/capture_online_payment_response",
    LIST: "LIS/master/list/patient_appointment_payment_detail",
    // UPDATE: "LIS/master/update/patientmaster",
    // DELETE: "LIS/master/delete/patientmaster",
    DOWNLOAD_CSV: "LIS/master/patient_appointment_payment_detail/downloadcsv",
    // DOCUMENTTYPELIST: "LIS/master/list/documentmaster",
  },
  FRANCHISE_ADVANCE_PAYMENT: {
    CREATE: "accounts/master/create/franchiseadvancepaymentmaster",
    ORDER_CREATE: "accounts/master/create/create_advance_online_payments_order",
    PAYU_ORDER_CREATE:
      "accounts/master/create/create_advance_online_payments_order_payu",
    CAPTURE_CREATE:
      "accounts/master/create/capture_advance_online_payment_response",
    LIST: "LIS/master/list/patient_appointment_payment_detail",
    LIST_BY_BARCODE_ID: "LIS/master/list/actual_data_received_from_machine",
    // UPDATE: "LIS/master/update/patientmaster",
    // DELETE: "LIS/master/delete/patientmaster",
    LIST_BY_MACHINE_ID_OBSERVATIONS: "LIS/master/host/code/mapped/observation",
    DOWNLOAD_CSV: "LIS/master/patient_appointment_payment_detail/downloadcsv",
    // DOCUMENTTYPELIST: "LIS/master/list/documentmaster",
  },
  ONLINE_PAYMENT_DETAILS: {
    CREATE: "LIS/master/create/online_payments_with_detail",
    ORDER_CREATE: "LIS/master/create/online_payments_create_order",
    CAPTURE_CREATE: "LIS/master/create/capture_online_payment_response",
    VIEW_LIST: "LIS/master/list/online_payment_detail",
    LIST: "LIS/master/list/online_payments",
    // UPDATE: "LIS/master/update/patientmaster",
    DELETE: "LIS/master/delete/online_payment_detail",
    DOWNLOAD_CSV: "LIS/master/online_payment_detail/downloadcsv",
    // DOCUMENTTYPELIST: "LIS/master/list/documentmaster",
  },
  PANNEL_WISE_BUSISSENES_REPORT: {
    // CREATE: "LIS/master/create/documentmaster",
    UPLOADDOCUMENT: "result_entry/upload_patient_investigation_doc",
    CREATEPATIENTLABRESULTENTRY: "result_entry/update_results",
    CREATE_PATIENT_LOGIN_DETAIL: "LIS/master/create/patient_login_detail",
    LIST: "reports/panel/business/report",
    ACCOUNT: "reports/panel/business/account/summary",
    DAILY_SUMMARY: "reports/panel/business/report/daily/summary",
    FRANCHISE_SUPER_FRANCHISE_SUMMARY:
      "reports/panel/bussiness/franchise/summary/report",
    FRANCHISE_SUPER_FRANCHISE_SUMMARY_TWO:
      "reports/panel/business/credit/debit/report",
    //  UPDATE: "LIS/master/update/documentmaster",
    DELETE: "LIS/master/delete/documentmaster",
    DOWNLOAD_CSV: "LIS/master/documentmaster/downloadcsv",
  },
  PAYMENT_TYPE_SEARCH_REPORT: {
    CREATE: "LIS/master/create/documentmaster",
    LIST: "reports/payment/type/search/report",
    //  UPDATE: "LIS/master/update/documentmaster",
    DELETE: "LIS/master/delete/documentmaster",
    DOWNLOAD_CSV: "LIS/master/documentmaster/downloadcsv",
  },
  LIS_ADMIN: {
    CREATE: "LIS/master/create/full/companyusermaster",
    LIST: "LIS/master/list/full/companyusermaster",
    DELETE: "LIS/master/delete/companymaster",
    UPDATE: "LIS/master/update/full/companyusermaster",
    DOWNLOAD_CSV: "LIS/master/companymaster/downloadcsv",
  },
  COMPANY_USER: {
    LIST: "LIS/master/list/companyusermaster",
  },
  KYC_VERIFICATION: {
    CREATE: "LIS/master/create/franchise_kyc_document",
    LIST: "LIS/master/list/franchise_kyc_document",
    DELETE: "LIS/master/delete/franchise_kyc_document",
    DOWNLOAD_CSV: "LIS/master/documentmaster/downloadcsv",
  },
  MACHINE_DATA: {
    CREATE: "LIS/master/create/franchise_kyc_document",
    BULK_UPDATE: "LIS/master/bulk_update/actual_data_received_from_machine",
    BULK_UPDATE_OBSERVATIONS:
      "LIS/master/bulkupdate_create_from_machine_data/investigation_observation_host_code",
    LIST: "LIS/master/list/actual_data_received_from_machine",
    LIST_BY_BARCODE_ID: "LIS/master/list/actual_data_received_from_machine",
    LIST_BY_MACHINE_ID_OBSERVATIONS: "LIS/master/host/code/mapped/observation",
    PENDING_OBSERVATION_LIST: "result_entry/appointment/pending/observation",
    DELETE: "LIS/master/delete/franchise_kyc_document",
    DOWNLOAD_CSV: "LIS/master/documentmaster/downloadcsv",
  },
  CREATEDEPARTMENT: "hrms/master/create/department",
  CREATEBRANCH: "hrms/master/create/branch",
  COUNTRIES: "LIS/country/master/list",
  STATEBYCOUNTRY: "LIS/get_state/",
  CITYBYSTATE: "LIS/get_city/",
  ZONELIST: "LIS/zone/master",
  CREATEROLE: "hrms/master/create/roles",
  CREATEDESIGNATION: "hrms/master/create/designation",
  GETDEPARTMENT: "hrms/master/list/department",
  PANELTYPEMASTER: "LIS/master/create/franchisetypes",
  ADDZONEMASTER: "LIS/master/create/zone",
  ADDAREAMASTER: "LIS/master/create/areamaster",
  ADDCIRUCLARMASTER: "LIS/master/create/circularmaster",
  DISCOUNTMASTER: "LIS/master/create/discount_reasonmaster",
  DOCTORMASTER: "LIS/master/create/doctor_degreemaster",
  DOCTORSPECIALIZATION: "LIS/master/create/doctor_specializationmaster",
  BRANCHLISTING: "hrms/master/list/branch/",
  DELETEBRANCH: "hrms/master/delete/branch/",
  CREATENEWREGISTRATION: "LIS/new/registration",
  UPLOADDOCUMENT: "LIS/master/create/patientdocument",
  UPDATEUPLOADDOCUMENT: "LIS/master/update/patientdocument",
  CHECKNEWREGISTRATION: "LIS/new/registration/check",

  OBSERVATION: {
    CREATE: "LIS/master/create/observationmaster",
    LIST: "LIS/master/list/observationmaster",
    UPDATE: "LIS/master/update/observationmaster",
    DELETE: "LIS/master/delete/observationmaster",
    DOWNLOAD_CSV: "LIS/master/observationmaster/downloadcsv",
    UPDATERANGE: "LIS/master/update/observationrange",
    DELETERANGE: "LIS/master/delete/observationrange",
  },
  RESULT_ENTRY_REPORT: {
    // CREATE: "LIS/master/create/documentmaster",
    LIST: "result_entry",
    FRANCHISE_PATIENT_REPORT_LIST: "result_entry/patient_report",
    PDF_LIST: "result_entry/generate/report/pdf",
    GENERATE_PDF_MULTIPLES_INVESTIGATION:
      "result_entry/generate/multiple/investigation/report/pdf",
    QRCODE_PDF: "reports/lis/reports",
    PDF_DOWNLOAD_LIST: "result_entry/appointment/generate_report_pdf",
    INVESTIGATION_DOCUMENT_DOWNLOAD:
      "result_entry/upload_patient_investigation_doc",
    VIEW_OBSERVATION_LIST: "LIS/new/registration/get_registration_detail",
    VIEW_PATIENT_LIST: "LIS/master/list/patientdocument",
    DOWNLOAD_PATIENT_DOCUMENT_LIST:
      "LIS/master/patientdocument/download_document",
    RESULT_ENTRY_DOWNLOAD_PATIENT_DOCUMENT_LIST:
      "result_entry/upload_patient_investigation_doc",
    RESULT_ENTRY_DELETE_PATIENT_DOCUMENT:
      "result_entry/delete_patient_investigation_doc",
    OBSERVATION_LIST: "result_entry/get_investigation_observations",
    ONLY_ORGANISM_LIST: "LIS/master/list/investigationmaster_dd",
    INVESTIGATION_OBSERVATION_DD_LIST:
      "LIS/master/list/investigation_observationmaster_dd",
    INVESTIGATION_OBSERVATION_DD:
      "LIS/master/list/investigation_observationmaster_dd",
    GENERATE_PDF: "result_entry/appointment/generate_report_pdf_node",
    MULTIPLE_GENERATE_PDF:
      "result_entry/appointment/multiple/generate_report_pdf_node",
    DOWNLOAD_INVESTIGATION_DOCUMENT_LIST:
      "result_entry/upload_patient_investigation_doc",
    CHECK_DOWNLOAD_ALLOWED: "LIS/new/registration/check",
    //  UPDATE: "LIS/master/update/documentmaster",
    DELETE: "LIS/master/delete/documentmaster",
    DOWNLOAD_CSV: "LIS/master/documentmaster/downloadcsv",
    UPDATE_STATUS: "result_entry/bulk_update/update_status",
  },
  COMMISSION_REPORT: {
    CREATE: "LIS/master/create/franchise_commission_master",
    LIST: "LIS/master/list/franchise_commission_master",
    UPDATE: "LIS/master/update/franchise_commission_master/",
    DELETE: "LIS/master/delete/franchise_commission_master",
    DOWNLOAD_CSV: "LIS/master/franchise_commission_master/downloadcsv",
  },
  FRANCHISE_COMMISSION_DETAIL: {
    CREATE: "LIS/master/create/franchise_commission_detail",
    LIST: "LIS/master/list/franchise_commission_detail",
    LIST_BY_ID: "LIS/master/list/franchise_commission_detail_by_id",
  },
  HEADER_FOOTER: {
    CREATE: "LIS/master/create/report_header_footer",
    LIST: "LIS/master/list/report_header_footer/",
    DELETE: "LIS/master/delete/report_header_footer",
  },
  PROFILE_PICTURE: {
    CREATE: "hrms/master/create/employee_profile_picture",
    LIST_BY_ID: "hrms/master/employee_profile_picture/download_document",
    DELETE: "hrms/master/delete/employee_profile_picture",
  },
  MACHINE_MASTER: {
    CREATE: "LIS/master/create/machinemaster",
    LIST: "LIS/master/list/machinemaster",
    UPDATE: "LIS/master/update/machinemaster",
    DELETE: "LIS/master/delete/machinemaster",
    DOWNLOAD_CSV: "LIS/master/machinemaster/downloadcsv",
  },
  OBSERVATION_HOST_CODE_MASTER: {
    CREATE: "LIS/master/create/investigation_observation_host_code",
    LIST: "LIS/master/list/investigation_observation_host_code",
    UPDATE: "LIS/master/update/investigation_observation_host_code",
    BULK_UPDATE:
      "LIS/master/bulkupdate_create/investigation_observation_host_code",
    DELETE: "LIS/master/delete/investigation_observation_host_code",
    DOWNLOAD_CSV: "LIS/master/investigation_observation_host_code/downloadcsv",
    OBSERVATION_ID_MACHINE_ID:
      "LIS/master/list/investigation_observation_host_code_by_observation_id_machine_id",
  },
  REPORT_ROLE: {
    CREATE: "result/reports/create/roles",
    LIST: "result/reports/get/roles",
    UPDATE: "result/reports/update/roles",
    DELETE: "result/reports/delete/roles",
    DOWNLOAD_CSV: "hrms/master/reportrole/downloadcsv",
  },
  ASSIGN_ROLE: {
    CREATE: "result/reports/assign/roles",
    LIST: "result/reports/get/assign/roles",
    LIST_BY_ID: "result/reports/get/employee/assign/roles",
    UPDATE: "result/reports/update/assign/roles",
    DELETE: "result/reports/delete/assigns/role",
    DOWNLOAD_CSV: "result_entry/assign/report/rolesdownloadcsv",
  },
  FIREBASE: {
    UPDATE: "hrms/master/update/employee_notifications",
    CREATE: "hrms/master/reset_firebase_token/employee",
    EMPLOYEE_NOTIFICATION: "hrms/master/employee/send_notification",
    EMPLOYEE_NOTIFICATION_LIST: "hrms/master/list/employee_notification",
    EMPLOYEE_NOTIFICATION_LISTS: "hrms/master/list/employee_notifications",
  },
  EMPLOYEEALLOCATE: {
    CREATE: "hrms/master/create/employee_zone_allocation",
    BULK_CREATE: "hrms/master/bulkcreate/employee_zone_allocation",
    LIST: "hrms/master/list/employee_zone_allocation/zone_dd",
    UPDATE: "hrms/master/update/employeecategorymaster",
    DELETE: "hrms/master/delete/employee_zone_allocation",
    DOWNLOAD_CSV: "hrms/master/employeecategorymaster/downloadcsv",
  },
  PACKAGE_COPY_RATE: {
    LIST: "LIS/master/list/franchise_package_rate",
    CREATE: "LIS/master/create/franchise_package_rate",
    BULK_CREATE: "LIS/master/bulkcreateupdate/franchise_package_rate",
    BULK_CREATE_ONLY: "LIS/master/bulkcreateonly/franchise_package_rate",
    SYNC: "LIS/master/franchisemaster/sync_all_package_to_rate_master",
    VIEW_FRANCHISE_PACKAGE_RATES_LIST:
      "LIS/master/list/view_franchise_wise_package_rate_list",
  },
  VENDOR: {
    CREATE: "inventory/master/create/vendormaster",
    LIST: "inventory/master/list/vendormaster",
    VENDOR_LIST_BY_ID: "inventory/master/list/vendormaster_by_id",
    UPDATE: "inventory/master/update/vendormaster",
    DELETE: "inventory/master/delete/vendormaster",
    DOWNLOAD_CSV: "inventory/master/vendormaster/downloadcsv",
  },
  PRODUCT: {
    CREATE: "inventory/master/create/productmaster",
    LIST: "inventory/master/list/productmaster",
    PRODUCT_LIST_BY_ID: "inventory/master/list/productmaster_by_id",
    UPDATE: "inventory/master/update/productmaster",
    DELETE: "inventory/master/delete/productmaster",
    DOWNLOAD_CSV: "inventory/master/productmaster/downloadcsv",
  },
  PRODUCT_TYPE: {
    CREATE: "inventory/master/create/producttypemaster",
    LIST: "inventory/master/list/producttypemaster",
    LIST_DD: "inventory/master/list/producttypemaster_dd",
    PRODUCT_LIST_BY_ID: "inventory/master/list/productmaster_by_id",
    UPDATE: "inventory/master/update/producttypemaster",
    DELETE: "inventory/master/delete/producttypemaster",
    DOWNLOAD_CSV: "inventory/master/producttypemaster/downloadcsv",
  },
  ATTENDANCE: {
    CREATE: "inventory/master/create/productmaster",
    LIST: "hrms/master/list/loginlog",
    UPDATE: "inventory/master/update/productmaster",
    DELETE: "inventory/master/delete/productmaster",
    DOWNLOAD_CSV: "inventory/master/productmaster/downloadcsv",
  },
  EMPLOYEE_ACTIVITY: {
    CREATE_MARK_LOGIN: "hrms/master/loginlog/mark_login",
    CREATE_MARK_LOGOUT: "hrms/master/loginlog/mark_logout",
  },
  INVENTORY_TERMS_CONDITION: {
    CREATE: "inventory/master/create/terms_condition",
    LIST: "inventory/master/list/terms_condition",
    TERMS_CONDITION_LIST_BY_ID: "inventory/master/list/terms_condition_by_id",
    UPDATE: "inventory/master/update/terms_condition",
    DELETE: "inventory/master/delete/terms_condition",
    DOWNLOAD_CSV: "inventory/master/terms_condition/downloadcsv",
  },
  PURCHASE_ORDER: {
    CREATE: "inventory/master/create/full/purchase_order",
    LIST: "inventory/master/list/purchase_order",
    LIST_BY_ID: "inventory/master/list/purchase_order",
    UPDATE: "inventory/master/update/full_purchase_order",
    APPROVE_UPDATE: "inventory/master/update/approve_purchase_order",
    RECEIVE_UPDATE: "inventory/master/purchase_order/mark_receive_order",
    DELETE: "inventory/master/delete/purchase_order",
    DOWNLOAD_CSV: "inventory/master/purchase_order/downloadcsv",
  },
  STOCKIN: {
    CREATE: "inventory/master/stockin_stockout_inventory/inventory_stockin",
    LIST: "inventory/master/list/stockin_stockout_inventory",
    PRODUCT_LIST_BY_ID: "inventory/master/list/productmaster_by_id",
    UPDATE: "inventory/master/update/stockin_stockout_inventory",
    DELETE: "inventory/master/delete/stockin_stockout_inventory",
    DOWNLOAD_CSV: "inventory/master/stockin_stockout_inventory/downloadcsv",
  },
  STOCKOUT: {
    CREATE: "inventory/master/stockin_stockout_inventory/inventory_stockout",
    LIST: "inventory/master/list/stockin_stockout_inventory",
    PRODUCT_LIST_BY_ID: "inventory/master/list/productmaster_by_id",
    UPDATE: "inventory/master/update/stockin_stockout_inventory",
    DELETE: "inventory/master/delete/stockin_stockout_inventory",
    DOWNLOAD_CSV: "inventory/master/stockin_stockout_inventory/downloadcsv",
  },
  EMPLOYEE_LEAVE: {
    CREATE: "hrms/master/create/employee_leaves_application",
    LIST: "hrms/master/list/employee_leaves_application",
    LEAVE_LEDGER_SUMMARY_LIST:
      "hrms/master/list/employee_leaves_ledger_summary",
    LEAVE_HISTORY_LIST: "hrms/master/list/employee_leaves_history",
    LEAVE_HISTORY_BY_ID_LIST: "hrms/master/list/employee_leaves_history",
    LIST_BY_ID: "hrms/master/list/employee_leaves_application",
    UPDATE: "hrms/master/update/employee_leaves_application",
    APPROVE_UPDATE: "inventory/master/update/approve_purchase_order",
    RECEIVE_UPDATE: "inventory/master/purchase_order/mark_receive_order",
    DELETE: "hrms/master/delete/employee_leaves_application",
    DOWNLOAD_CSV: "inventory/master/purchase_order/downloadcsv",
  },
  PAYMENT_LEDGER: {
    LIST: "accounts/payment/ledger/list",
    HISTORY_LIST: "accounts/payment/ledger/history/list",
  },
  COMMISSION_LEDGER: {
    LIST: "accounts/commissions/list",
    HISTORY_LIST: "accounts/commissions/history/list",
    REPORT_LIST: "accounts/commission/monthly/list",
    COMMISSION_LEDGER_CARDS_LIST: "accounts/commission/dashboard",
  },
  CREDIT_TRANSFER: {
    CREATE: "accounts/transfer/credit",
    LIST: "accounts/credit/transfer/list",
  },
  APPSTORE: {
    CREATE: "CompanyAppStore/master/create/app_store",
    LIST_BY_APP_NAME: "CompanyAppStore/master/list/app_store/",
    LIST: "CompanyAppStore/master/list/app_store",
    DELETE: "CompanyAppStore/master/delete/app_store",
    UPDATE: "CompanyAppStore/master/update/app_store/",
    DOWNLOAD_CSV: "CompanyAppStore/master/app_store/downloadcsv",
  },
  COMPANY_APPSTORE: {
    CREATE: "CompanyAppStore/master/create/company_app_store",
    LIST_BY_APP_ID: "CompanyAppStore/master/list/company_app_store/",
    LIST: "CompanyAppStore/master/list/company_app_store",
    DELETE: "CompanyAppStore/master/delete/company_app_store",
    UPDATE: "CompanyAppStore/master/update/company_app_store",
    DOWNLOAD_CSV: "CompanyAppStore/master/company_app_store/downloadcsv",
  },
 
  LAB_DEPARTMENT_WISE_IP_RATES: {
    CREATE: "LIS/master/create/lab_department_ip_rate",
    LIST: "LIS/master/lab_department_ip_rate/all_ip_rates",
    UPDATE: "LIS/master/update/lab_department_ip_rate",
    BULK_UPDATE: "LIS/master/bulk_update_create/lab_department_ip_rate",
    DELETE: "LIS/master/delete/lab_department_ip_rate",
    SYNC: "LIS/master/lab_department_ip_rate/sync_package_and_department",
    DOWNLOAD_CSV: "hrms/master/department/downloadcsv",
  },
  LAB_DEPARTMENT_IP_RATE_DOCTOR: {
    CREATE: "LIS/master/create/lab_department_doctor_ip_rate",
    LIST: "LIS/master/list/lab_department_doctor_ip_rate",
    UPDATE: "LIS/master/update/lab_department_doctor_ip_rate",
    DELETE: "LIS/master/delete/lab_department_doctor_ip_rate",
    DOWNLOAD_CSV: "hrms/master/department/downloadcsv",
  },
  DOCTOR_IP_CALCULATION: {
    CREATE: "LIS/master/create/areamaster",
    LIST: "LIS/master/list/doctor_ip_calculation",
    DETAILS_LIST: "LIS/master/list/doctor_ip_calculation_detail",
    UPDATE: "LIS/master/update/areamaster",
    DELETE: "LIS/master/delete/areamaster",
    DOWNLOAD_CSV: "LIS/master/areamaster/downloadcsv",
  },
  DOCTOR_TEST_CHARGES: {
    CREATE: "LIS/master/create/doctor_test_charge",
    LIST: "LIS/master/list/doctor_test_charge",
    DETAILS_LIST: "LIS/master/list/doctor_ip_calculation_detail",
    UPDATE: "LIS/master/update/doctor_test_charge",
    DELETE: "LIS/master/delete/doctor_test_charge",
    DOWNLOAD_CSV: "LIS/master/areamaster/downloadcsv",
  },
  MEMBERSHIP_CARD: {
    CREATE: "LIS/master/create/membership_card",
    LIST: "LIS/master/list/membership_card",
    ORDERS_LIST: "LIS/master/list/patient_membership_order_detail",
    LIST_DD: "LIS/master/list/membership_card_dd",
    UPDATE: "LIS/master/update/membership_card",
    DELETE: "LIS/master/delete/membership_card",
    DOWNLOAD_CSV: "LIS/master/branch/downloadcsv",
  },
  MEMBERSHIP_RATES: {
    CREATE: "LIS/master/create/test_ratemaster",
    LIST: "LIS/master/list/membership_rate",
    MEDICITY_FRANCHISE_COPY_RATE_LIST:
      "LIS/master/list/panel_wise_test_ratemaster",
    FRANCHISE_INVESTIGATION_DETAILS: "LIS/show/investigation/all_detail",
    PENDING_LIST: "LIS/get/pending/rate",
    UPDATE: "LIS/master/bulk_add_update/membership_rate",
    MEMBERSHIP_LIST_DETAIL: "LIS/master/list/patient_membership_order_detail",
    MEMBERSHIP_CREATE:
      "LIS/master/create/patient_membership_order_detail/with_payments",
    MEMBERSHIP_UPDATE: "LIS/master/update/patient_membership_order_detail",
    MEMBERSHIP_UPGRADE:
      "LIS/master/create/patient_membership_order_detail/upgrade_cards",
    MEDICITY_UPDATE: "LIS/master/LIS/update/bulk_update_test_ratemaster",
    DELETE: "LIS/master/delete/test_ratemaster",
    DOWNLOAD_CSV: "LIS/master/test_ratemaster/downloadcsv",
    COPY_RATES: "LIS/copy/rate/list",
    SYNC: "LIS/master/franchisemaster/sync_all_investigations_to_test_rate_master",
  },
  PATIENT_COORDINATOR_AGENTS: {
    CREATE: "hrms/master/create/patient_coordinator_agent",
    LIST: "hrms/master/list/patient_coordinator_agent",
    UPDATE: "hrms/master/update/patient_coordinator_agent",
    DELETE: "hrms/master/delete/employee",
    DOWNLOAD_CSV: "hrms/master/employee/downloadcsv",
  },
  LAB_DEPARTMENT_WISE_COORDINATOR_RATES: {
    CREATE: "LIS/master/create/lab_department_patient_coordinators_rate",
    LIST: "LIS/master/lab_department_patient_coordinators_rate/all_ip_rates",
    LIST_DEPARTMENT_WISE_RATE:
      "LIS/master/list/lab_department_patient_coordinators_rate",
    UPDATE: "LIS/master/update/lab_department_patient_coordinators_rate",
    BULK_UPDATE:
      "LIS/master/bulk_update_create/lab_department_patient_coordinators_rate",
    DELETE: "LIS/master/delete/lab_department_patient_coordinators_rate",
    SYNC: "LIS/master/lab_department_patient_coordinators_rate/sync_package_and_department",
    DOWNLOAD_CSV: "hrms/master/department/downloadcsv",
  },
  PATIENT_COORDINATOR_CHARGES: {
    CREATE: "LIS/master/create/areamaster",
    LIST: "LIS/master/list/appointment_patient_coordinators_charge",
    DETAILS_LIST:
      "LIS/master/list/appointment_patient_coordinators_charge_detail",
    UPDATE: "LIS/master/update/areamaster",
    DELETE: "LIS/master/delete/areamaster",
    DOWNLOAD_CSV: "LIS/master/areamaster/downloadcsv",
  },
  LAB_DEPARTMENT_COORDINATOR_RATE: {
    CREATE: "LIS/master/create/patient_coordinators_rate",
    LIST: "LIS/master/list/patient_coordinators_rate",
    UPDATE: "LIS/master/update/patient_coordinators_rate",
    DELETE: "LIS/master/delete/patient_coordinators_rate",
    DOWNLOAD_CSV: "hrms/master/department/downloadcsv",
  },
  NAVBAR_SECTION: {
    CREATE: "hrms/master/create/navbar_section_master",
    LIST: "hrms/master/list/navbar_section_master",
    UPDATE: "hrms/master/update/navbar_section_master",
    DELETE: "hrms/master/delete/navbar_section_master",
    DOWNLOAD_CSV: "hrms/master/navbar_section_master/downloadcsv",
  },
  ROLE_SECTION_DETAIL: {
    CREATE: "hrms/master/create/role_section_detail",
    LIST: "hrms/master/list/role_section_detail",
    LIST_ID: "hrms/master/list/role_section_detail",
    UPDATE: "hrms/master/update/navbar_section_master",
    DELETE: "hrms/master/delete/role_section_detail",
    DOWNLOAD_CSV: "hrms/master/navbar_section_master/downloadcsv",
  },
  COLLECTION_REPORT: {
    DISCOUNT_REPORT_LIST: "b2c_reports/mis_reports/discount_report",
    COLLECTION_REPORT_LIST: "b2c_reports/mis_reports/collection_report",
    OUTSTANDING_REPORT_LIST: "b2c_reports/mis_reports/outstanding_report",
    ALL_PAYMENT_REPORT_LIST: "b2c_reports/mis_reports/all_payments_report",
    CARD_COLLECTION_REPORT_LIST:
      "b2c_reports/mis_reports/card_collection_report",
    BOOKING_COLLECTION_REPORT_LIST:
      "b2c_reports/mis_reports/booking_collection_report",
    INVESTIGATION_REPORT_LIST:
      "b2c_reports/mis_reports/investigation_wise_report",
    FRANCHISE_INVOICE_REPORT_LIST:
      "invoice_reports/invoice_reports/franchise_invoice_report",
    CREATE_FRANCHISE_INVOICE_REPORT_LIST:
      "accounts/master/create/full_franchise_booking_invoice",
  },
  FRANCHISE_INVOICE_REPORT: {
    CREATE_FRANCHISE_INVOICE_REPORT_LIST:
      "accounts/master/create/full_franchise_booking_invoice",
    LIST_FRANCHISE_INVOICE_REPORT_LIST:
      "accounts/master/list/franchise_booking_invoice",
  },
  PATIENT_COORDINATOR_AGENTS_ONBOARDING_APPLICATION: {
    CREATE:
      "hrms/master/create/patient_coordinator_agent_onboarding_application",
    LIST: "hrms/master/list/patient_coordinator_agent_onboarding_application",
    UPDATE:
      "hrms/master/update/patient_coordinator_agent_onboarding_application",
    DELETE:
      "hrms/master/delete/patient_coordinator_agent_onboarding_application",
    APPROVAL:
      "hrms/master/patient_coordinator_agent_onboarding_application/approve_application",
    DOWNLOAD_CSV: "hrms/master/employee/downloadcsv",
  },
  DOCTOR_ONBOARDING_APPLICATION: {
    CREATE: "LIS/master/create/doctors_master_onboarding_application",
    LIST: "LIS/master/list/doctors_master_onboarding_application",
    DOCTOR_ASSIGN_ROLE: "result/reports/get/employee/assign/doctor",
    UPDATE: "LIS/master/update/doctors_master_onboarding_application",
    DELETE: "LIS/master/delete/doctors_master_onboarding_application",
    APPROVAL:
      "LIS/master/doctors_master_onboarding_application/approve_application",
    DOWNLOAD_CSV: "hrms/master/employee/downloadcsv",
  },
  FRANCHISE_ONBOARDING_APPLICATION: {
    CREATE: "LIS/create/franchise_onboarding_application/master",
    LIST: "LIS/franchise_master_onboarding_application/master/list",
    DOCTOR_ASSIGN_ROLE: "result/reports/get/employee/assign/doctor",
    UPDATE:
      "LIS/master/update/franchise_master_onboarding_application_onboarding_application",
    DELETE:
      "LIS/master/delete/franchise_master_onboarding_application_onboarding_application",
    APPROVAL:
      "LIS/master/franchise_master_onboarding_application/approve_application",
    DOWNLOAD_CSV: "hrms/master/employee/downloadcsv",
  },
  SAMPLE_COLLECT_BY_BARCODE: {
    CREATE: "LIS/master/sample/barcode_search_and_mark_collected",
  },
  TAT_REPORT: {
    LIST: "reports/report/investigation_tat/report",
    LIST_GRAPHICAL: "reports/report/investigation_tat/graph_report",
  },
  APPOINTMENT_CANCELLATIONS: {
    CREATE: "hrms/master/create/branch",
    LIST: "LIS/master/list/patient_appointment_cancellation_master",
    DETAIL: "LIS/master/list/patient_appointment_cancellation_detail",
    UPDATE: "hrms/master/update/branch",
    DELETE: "hrms/master/delete/branch",
    DOWNLOAD_CSV: "hrms/master/branch/downloadcsv",
  },
  MARKETING_PERSON_BUSINESS_REPORT: {
    CREATE: "hrms/master/create/branch",
    LIST: "reports/marketing_person/stats/franchise_report",
    DETAIL: "reports/marketing_person/detail/franchise_detail",
    UPDATE: "hrms/master/update/branch",
    DELETE: "hrms/master/delete/branch",
    DOWNLOAD_CSV: "hrms/master/branch/downloadcsv",
  },
  DOCTOR_PERFORMING_CHARGES: {
    CREATE: "LIS/master/create/doctor_test_charge",
    LIST: "LIS/master/list/performing_doctor_charge",
    DETAILS_LIST: "LIS/master/list/doctor_ip_calculation_detail",
    UPDATE: "LIS/master/update/doctor_test_charge",
    DELETE: "LIS/master/delete/areamaster",
    DOWNLOAD_CSV: "LIS/master/areamaster/downloadcsv",
  },
  DOCTOR_PERFORMING_CHARGES_DETAILS: {
    CREATE: "LIS/master/create/doctor_test_charge",
    LIST: "LIS/master/list/performing_doctor_charge_detail",
    DETAILS_LIST: "LIS/master/list/performing_doctor_charge_detail",
    UPDATE: "LIS/master/update/doctor_test_charge",
    DELETE: "LIS/master/delete/areamaster",
    DOWNLOAD_CSV: "LIS/master/areamaster/downloadcsv",
  },
  EMPLOYEE_TARGET: {
    CREATE: "hrms/master/create/employee_target",
    LIST: "hrms/master/list/employee_target",
    UPDATE: "hrms/master/update/employee_target",
    DELETE: "hrms/master/delete/employee_target_by_id",
    DOWNLOAD_CSV: "hrms/master/branch/downloadcsv",
    BY_EMPLOYEE_ID: "hrms/master/list/employee_target",
  },
  DOCTOR_CLINIC_ROUTER: {
    CREATE: "opd/master/create/doctor_clinic_master",
    LIST: "opd/master/list/doctor_clinic_master",
    UPDATE: "opd/master/update/doctor_clinic_master",
    DELETE: "opd/master/delete/doctor_clinic_master",
    DOWNLOAD_CSV: "opd/master/doctor_clinic_master/downloadcsv",
    DROPDOWN: "opd/master/list/doctor_clinic_master_dd",
  },
  DOCTOR_OPD_CHARGE_ROUTER: {
    LIST: "opd/master/list/doctor_opd_charge",
    CREATE: "opd/master/create/doctor_opd_charge",
    UPDATE: "opd/master/update/doctor_opd_charge",
    DELETE: "opd/master/delete/doctor_opd_charge",
    DOWNLOAD_CSV: "opd/master/doctor_opd_charge/downloadcsv",
  },
  DOCTOR_SCHEDULE_ROUTER: {
    CREATE: "opd/master/create/doctor_schedule",
    LIST: "opd/master/list/doctor_schedule",
    UPDATE: "opd/master/update/doctor_schedule",
    DELETE: "opd/master/delete/doctor_schedule",
    DOWNLOAD_CSV: "opd/master/doctor_schedule/downloadcsv",
    DROPDOWN: "opd/master/list/doctor_schedule_dd",
  },
  DOCTOR_OPD_BILL_ITEM: {
    CREATE: "opd/master/create/doctor_opd_bill_item",
    LIST: "opd/master/list/doctor_opd_bill_item",
    UPDATE: "opd/master/update/doctor_opd_bill_item",
    DELETE: "opd/master/delete/doctor_opd_bill_item",
    DOWNLOAD_CSV: "opd/master/doctor_opd_bill_item/downloadcsv",
    DROPDOWN: "opd/master/list/doctor_opd_bill_item_dd",
    DETAIL: "opd/master/list/doctor_opd_bill_item_full_detail",
  },
  DOCTOR_OPD_BILL_PAYMENT: {
    CREATE: "opd/master/create/doctor_opd_bill_payment",
    LIST: "opd/master/list/doctor_opd_bill_payment",
    UPDATE: "opd/master/update/doctor_opd_bill_payment",
    DELETE: "opd/master/delete/doctor_opd_bill_payment",
    DOWNLOAD_CSV: "opd/master/doctor_opd_bill_payment/downloadcsv",
    DROPDOWN: "opd/master/list/doctor_opd_bill_payment_dd",
    DETAIL: "opd/master/list/doctor_opd_bill_payment_full_detail",
  },
  DOCTOR_OPD_APPOINTMENT: {
    CREATE: "opd/master/create/doctor_opd_appointment",
    LIST: "opd/master/list/doctor_opd_appointment",
    UPDATE: "opd/master/update/doctor_opd_appointment",
    DELETE: "opd/master/delete/doctor_opd_appointment",
    DOWNLOAD_CSV: "opd/master/doctor_opd_appointment/downloadcsv",
    DROPDOWN: "opd/master/list/doctor_opd_appointment_dd",
    DETAIL: "opd/master/list/doctor_opd_appointment_full_detail",
  },
};
